import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.12.2_@parcel+watcher@2.4.1_@types+node@22.13.0_encoding@0.1.13_eslint@8.57.0_ioredis@5_a2dqfe3dyz7osebaixv3iw3xri/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}